<template>
  <form id="donation-payment" class="card w-modal h-modal">
    <div class="header">
      <div class="title">
        <div class="flex flex-col">
          <h1 class="mb-2">New Donation</h1>
          <div class="flex flex-row">
            <h4 class="opacity-50">Donation Details</h4>
            <h4 class="ml-4 mr-4 opacity-50">></h4>
            <h4 class="opacity-50">Supporter Details</h4>
            <h4 class="ml-4 mr-4">></h4>
            <h4>Payment</h4>
          </div>
        </div>
      </div>
      <div class="close" @click="close()">
        <i class="icn icn-x sm"></i>
      </div>
    </div>

    <div class="content" v-show="isSendingSms">
      <div class="flex flex-col items-center">
        <img class="h-40 mb-14 mt-20" src="@/assets/img/loading.svg" />
        <div class="flex flex-col items-center">
          <h1 class="mb-10">Sending a text message to {{ payload.supporter.phoneNumber }}</h1>
        </div>
      </div>
    </div>

    <div class="content" v-show="isWaitingForPayment">
      <div class="flex flex-col items-center">
        <img class="h-40 mb-14 mt-20" src="@/assets/img/loading.svg" />
        <div class="flex flex-col items-center">
          <h1 class="mb-10">A text message has been sent to {{ payload.supporter.phoneNumber }}</h1>
          <h1>Waiting for the supporter to finalise the payment</h1>
          <h3 v-if="remotePaymentToken" class="mt-10">
            Last SMS is sent at: {{ remotePaymentToken.createdAt | moment }}
          </h3>
          <button
            v-if="!cooldown && !isResending && isAbleToResend"
            class="primary mt-2"
            type="button"
            @click="resendToken()"
          >
            Resend SMS
          </button>
          <button v-if="cooldown" class="secondary mt-2" disabled type="button" @click="resendToken()">
            Resend SMS in {{ cooldown }} seconds
          </button>
        </div>
      </div>
    </div>
  </form>
</template>

<script>
import moment from 'moment';
import { mapState } from 'vuex';

export default {
  name: 'DonationPaymentSms',
  data() {
    return {
      isSendingSms: true,
      isWaitingForPayment: false,
      webDonationModel: null,
      remotePaymentToken: null,
      donationInterval: null,
      resendInterval: null,
      message: null,
      cooldown: null,
      isAbleToResend: false,
      isResending: false,
    };
  },
  computed: {
    ...mapState({
      payload: (state) => state.donationModal.payload,
    }),
  },
  async mounted() {
    try {
      this.isSendingSms = true;
      // create sms donation
      this.remotePaymentToken = await this.$store.dispatch('donationModal/createDonation', this.payload);
      // this.$store.dispatch('dotp/getAll');
      this.isWaitingForPayment = true;
      this.donationInterval = setInterval(this.checkDonationStatus, 10000);
      this.resendInterval = setInterval(this.setCooldown, 1000);
    } catch (err) {
      console.log(err);
      this.message = {
        content: 'Server is unable to send SMS.',
        type: 'error',
      };
      this.isWaitingForPayment = false;
    } finally {
      this.isSendingSms = false;
    }
  },
  methods: {
    close() {
      this.$store.dispatch('donationModal/close');
      this.$store.dispatch('donationModal/reset');
      clearInterval(this.donationInterval);
      clearInterval(this.resendInterval);
    },
    setCooldown() {
      const date1 = new Date(this.remotePaymentToken.createdAt);
      const date2 = new Date();
      const countDown = 60 - Math.floor((date2.getTime() - date1.getTime()) / 1000);
      if (countDown <= 0) {
        this.isAbleToResend = true;
        this.cooldown = null;
        clearInterval(this.resendInterval);
      } else {
        this.cooldown = countDown;
      }
    },
    async checkDonationStatus() {
      if (this.remotePaymentToken) {
        const { payload } = await this.$store.dispatch('donationModal/getDonation', this.remotePaymentToken.donationId);

        if (payload.transaction.status && payload.transaction.status != 'pending') {
          this.payload.transaction = payload.transaction;
          // this.$store.dispatch('dotp/getAll');
          clearInterval(this.donationInterval);
          this.$emit('nextStep');
        }
      }
    },
    async resendToken() {
      try {
        this.isResending = true;
        this.isAbleToResend = false;
        this.remotePaymentToken = await this.$store.dispatch(
          'donationModal/resendToken',
          this.remotePaymentToken.donationId,
        );
        this.resendInterval = setInterval(this.setCooldown, 1000);
      } catch (err) {
        console.log(err);
      } finally {
        this.isResending = false;
      }
    },
  },
  filters: {
    moment: function (date) {
      return moment(date).format('MMMM Do YYYY, h:mm:ss a');
    },
  },
};
</script>

<style></style>
